import axios from "axios";
import { ListQueryParams } from "@/models/table";

export const getActivistFilings = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, next_page_url } = params;

    const url = next_page_url || `/interface/api/institutional/activist_filings/list`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options };

    try {
        const res = await axios.get(url, {
            params: {
                ...defaultParams,
            },
            signal,
        });

        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getStockInstitutionalHolders = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, next_page_url, data } = params;

    const url = next_page_url || `/interface/api/institutional/holders/list`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options, ...data };

    try {
        const res = await axios.get(url, {
            params: {
                ...defaultParams,
            },
            signal,
        });

        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getActivistFilerHoldings = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, next_page_url, data } = params;

    const url = next_page_url || `/interface/api/institutional/filer/holdings/list`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options, ...data };

    try {
        const res = await axios.get(url, {
            params: {
                ...defaultParams,
            },
            signal,
        });

        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getActivistFilerFilings = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, next_page_url, data } = params;

    const url = next_page_url || `/interface/api/institutional/filer/filings/list`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options, ...data };

    try {
        const res = await axios.get(url, {
            params: {
                ...defaultParams,
            },
            signal,
        });

        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getActivistFilerDirectory = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, next_page_url, data } = params;

    const url = next_page_url || `/interface/api/institutional/filer/list`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options, ...data };

    try {
        const res = await axios.get(url, {
            params: {
                ...defaultParams,
            },
            signal,
        });

        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getActivistSummary = async () => {
    try {
        const res = await axios.get(`/interface/api/institutional/activist_filings/summary`);

        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getActivistFilerSummary = async (filerCik: string) => {
    try {
        const res = await axios.get(`/interface/api/institutional/filer/summary`, {
            params: { filer_cik: filerCik },
        });

        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getStockActivistInvestors = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, next_page_url, data } = params;

    const url = next_page_url || `/interface/api/institutional/activist_filings/stock/list`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options, ...data };

    try {
        const res = await axios.get(url, {
            params: {
                ...defaultParams,
            },
            signal,
        });

        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getStockActivistTimeline = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, next_page_url, data } = params;

    const url = next_page_url || `/interface/api/institutional/activist_filings/stock/timeline/list`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options, ...data };

    try {
        const res = await axios.get(url, {
            params: {
                ...defaultParams,
            },
            signal,
        });

        return res.data;
    } catch (err) {
        throw err;
    }
};
